import React from 'react'
import PropTypes from 'prop-types'
import {useCurrentUserId} from '#hooks/store/useCurrentUserId'
import Sent from '#components/svg/icons/Sent'
import Received from '#components/svg/icons/Received'
import {TriggerWithTooltip} from '#components/m/MeineAzubis/TriggerWithTooltip'

export default function FeedbackTitleWithIcon({feedback}) {
  const {currentUserId} = useCurrentUserId()
  const isAuthorOfFeedback = feedback.author.id === currentUserId
  const Icon = isAuthorOfFeedback ? <Sent /> : <Received />

  return (
    <>
      {Icon}
      <TriggerWithTooltip text={feedback.originalFilename} modifiers={['dark', 'nopadding']}>
        <span>{feedback.originalFilename}</span>
      </TriggerWithTooltip>
    </>
  )
}

FeedbackTitleWithIcon.propTypes = {
  feedback: PropTypes.shape({
    author: PropTypes.shape({
      id: PropTypes.number,
    }),
    originalFilename: PropTypes.string,
  }),
}
